import Link from 'components/Link'
import React, { useEffect, useState } from 'react'
import RightCol from '../RightCol'
import CallToAction from '../CallToAction'
import { Wrapper } from '../Wrapper'
import SearchIconButton from 'components/Search/SearchIconButton'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Trans, useI18next, useTranslation } from 'gatsby-plugin-react-i18next'
import { Listbox, Tab } from '@headlessui/react'
import { SelectorIcon } from '@heroicons/react/outline'
import { languageMetadata, languages } from 'utils/languages'
import { GlobalOutlined } from '@ant-design/icons'
import i18nConfigs from '../../../../../i18n/config.json'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'

const LanguageItem = ({ title, icon, url, url2, lang }) => {
    const { originalPath, languages, changeLanguage } = useI18next()
    // const { language } = useContext(I18nextContext)

    return (
        <li className="md:max-w-[100px]">
            <Link
                className="group relative flex h-full cursor-pointer flex-col items-center justify-start space-y-2 rounded-sm py-2 hover:top-[-.5px] hover:scale-[1.01] hover:bg-tan hover:bg-opacity-50 active:top-[.5px] active:scale-[.99] md:px-2"
                to={url}
                language={lang}
                onClick={() => {
                    changeLanguage(lang)
                    // window.history.pushState(null, '', `${language/url}`)
                }}
            >
                {icon && <span className="h-7 w-7  opacity-60 group-hover:opacity-100 dark:text-white">{icon}</span>}
                <h3 className="m-0 text-center text-sm font-bold leading-none opacity-70">{title}</h3>
            </Link>
        </li>
    )
}
const changeLang = ({ language }) => {
    // const { changeLanguage } = useI18next()
    // changeLanguage(language)
    if (typeof window !== 'undefined') {
        const url = new URL(window.location)
        // window.location.reload()
        window.history.pushState({}, '', url)
    }
}

export default function LanguageSwitcher({ referenceElement }: { referenceElement: HTMLDivElement }) {
    // same data as in the `config.json` but indexed by language code
    const { i18n } = useTranslation()
    const [redirectTo, setRedirect] = useState('')
    const [redirectTo2, setRedirect2] = useState('')
    const { pathname } = useLocation()
    useEffect(() => {
        let from = '/'
        const pathArray = pathname?.split('/')
        const pathArray2 = pathname?.split('/')
        pathArray.shift()
        if (i18n.language !== 'en') {
            pathArray.shift()
        }
        // console.log(`pathArray ${JSON.stringify(pathArray)}  ${i18n.language}`)
        if (pathArray.length >= 1) {
            from = '/' + pathArray[0]
        }
        // console.log(`from   ${from}`)
        setRedirect(from)
    }, [pathname])
    //const anchor = pathname?.startsWith('/product') && other.url?.includes('#')

    //     const {locales} = useStaticQuery(graphql`
    //     query Languages {
    //         locales: allLocale {
    //             edges {
    //                 node {
    //                     language
    //                 }
    //             }
    //         }
    //     }
    // `)
    //     <Dropdown overlay={menu} placement="bottomRight">
    //     <span className="langDropdown">
    //         <GlobalOutlined
    //             style={{
    //                 marginRight: '8px',
    //                 verticalAlign: 'unset',
    //             }}
    //         />
    //         {i18n.language === 'en' ? 'English' : 'العربية'}
    //     </span>
    // </Dropdown>
    const buildLangs = (process.env.GATSBY_BUILD_LANGS || '').split(',')
    let activeLangs = i18nConfigs
    if (buildLangs.length > 0) {
        activeLangs = i18nConfigs.filter((lang) => {
            return buildLangs.includes(lang.code)
        })
    }
    return (
        <Wrapper referenceElement={referenceElement} placement="bottom-end">
            <div>
                <section className="flex flex-col-reverse md:flex-col">
                    <h3 className="m-0 pl-2 text-[18px] font-bold text-black">Languages</h3>
                    <ol className="-mx-6 mt-2 mb-6 grid list-none grid-cols-2 space-x-[1px] border-b border-dashed border-gray-accent-light p-0 px-6 pb-4 dark:border-gray-accent-dark md:grid-cols-4">
                        {activeLangs?.length > 1 &&
                            activeLangs.map((language) => {
                                return (
                                    <LanguageItem
                                        lang={language.code}
                                        key={language.code}
                                        title={language.name || language.localName}
                                        url={redirectTo}
                                        url2={`${language.code}+/+${redirectTo}`}
                                    />
                                )
                            })}
                    </ol>
                </section>
            </div>
        </Wrapper>
    )
}
